'use strict';

function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
    $scope.global = Global;

    let model = this;
    model.settings = settings;
    model.lineChartIdentifiers = {
        key: false,
        id: false
    };
    model.tableIdentifiers = {
        key: false,
        id: false
    };
    model.complete = false;

    socketIo('/api/general_network/inbound_resp').then(function(socket) {
        /////////////////
        /// LINECHART ///
        /////////////////

        // register data object
        $scope.main.registerVisual({
                // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
                refresh: true, // if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                get: {
                    call: 'linechart',
                    socket: socket
                }, // no get default to main url, strings will replace the default (otherwise /[from root])
                grouping: ['hour'],
                type: 'linechart',
                settings: {
                    type: 'bandwidth',
                    toggleValues: true,
                    xAxis: '',
                    yAxis: '# MB / Hour'
                },
                searchCategories: {
                    'time': 'Time',
                },
                dimension: function(cfObj) {
                    return cfObj.dimension(function(d) {
                        if (d.time - d.hour < 3600) {
                            d.hour = Number(d.hour * 1000);
                            return d.hour;
                        }
                    })
                },
                group: function(dimension) { // groups are optional and should default to a reduce if undefined
                    return dimension.group().reduce(
                        function(p, v) {
                            p.bytes_to += v.bytes_orig;
                            p.bytes_from += v.bytes_resp;
                            return p;
                        },
                        function(p, v) {
                            p.bytes_to -= v.bytes_orig;
                            p.bytes_from -= v.bytes_resp;
                            return p;
                        },
                        function() {
                            return {
                                bytes_to: 0,
                                bytes_from: 0
                            };
                        }
                    );
                },
            })
            // fetch the data when the object is registered
            .then(function(result) {
                model.lineChartIdentifiers = {
                        id: result.id,
                        key: result.key
                    }
                    // set dimension & group
                $scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
                $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
                return new fetchStream(result.settings.get.call, result.settings.get.socket);
            })
            .then(function(result) {
                // stop spinner on complete
                if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
                    usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id)
                }
            }, function(err) {

            }, function(result) {
                $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
                    $scope.$broadcast('init', model.lineChartIdentifiers);
                    // stop spinner on inital data
                    usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id)
                } else {
                    $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
                }
            })

        /////////////
        /// TABLE ///
        /////////////

        // register data object
        $scope.main.registerVisual({
                // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
                refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                get: {
                    call: 'table',
                    socket: socket
                },
                grouping: [
                    'sensor',
                    'resp_hostname',
                    'resp_ip'
                ],
                sort: {
                    direction: '-', // '-' == desc, '+' == asc
                    col: 'time'
                },
                title: 'Inbound Responder IP Traffic',
                columns: [{
                    title: 'Last Seen',
                    select: 'time',
                    dView: true,
                    link: {
                        type: 'inbound_orig_country',
                        val: ['resp_hostname', 'resp_ip'],
                        crumb: false
                    },
                }, {
                    title: 'Sensor',
                    select: 'sensor',
                    dView: true
                }, {
                    title: 'Connections',
                    select: 'count',
                    dView: true
                }, {
                    title: 'Responder Local',
                    select: 'resp_local',
                    dView: true
                }, {
                    title: 'Responder Stealth',
                    select: 'resp_stealth',
                    dView: true
                }, {
                    title: 'Responder Hostname',
                    select: 'resp_hostname',
                    dView: true
                }, {
                    title: 'Responder User',
                    select: 'resp_user',
                    dView: true
                }, {
                    title: 'Responder IP',
                    select: 'resp_ip',
                    dView: true
                }, {
                    title: 'IOC Count',
                    select: 'ioc_count',
                    dView: true
                }, {
                    title: 'Vector',
                    select: 'vector',
                    dView: false
                }, {
                    title: 'Payload Ratio',
                    select: 'breakdown',
                    dView: true
                }, {
                    title: 'Origin Payload',
                    select: 'bytes_orig',
                    dView: true
                }, {
                    title: 'Responder Payload',
                    select: 'bytes_resp',
                    dView: true
                }, ],
                searchCategories: {
                    'ioc_count' : "IOC Count",
                    'resp_local': 'Responder Local',
                    'resp_stealth': 'Responder Stealth',
                    'resp_hostname': 'Responder Hostname',
                    'resp_user': 'Responder User',
                    'resp_ip': 'Responder IP',
                    'sensor': 'Sensor',
                    'vector': 'Vector',
                }
            })
            // fetch the data when the object is registered
            .then(function(result) {
                model.tableIdentifiers = {
                        id: result.id,
                        key: result.key
                    }
                    // initalize table with column information so it can compile the directive
                $scope.$broadcast('table-build', model.tableIdentifiers);

                let time = angular.copy($scope.main.getTime());
                model.loadStart = time.end
                model.loadEnd = time.end
                    // return promise to build dimensions and groups for table
                return new fetchStream(result.settings.get.call, result.settings.get.socket);
            })
            .then(function(result) {
                model.complete = true;
                // stop the table spinner as soon as the resolve comes in
                usSpinnerService.stop(model.tableIdentifiers.id);
            }, function(err) {

            }, function(result) {
                // add rows
                $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                    // with our first data return, we can build dimensions and groups for our data
                    $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function() {
                        // dont start the spinner if the table loads faster than building group dim
                        if (!model.complete) {
                            // start table spinner right before init, but after build
                            usSpinnerService.spin(model.tableIdentifiers.id);
                        }
                        // initalize rows
                        $scope.$broadcast('init', model.tableIdentifiers);
                        if (result.min) {
                            model.loadStart = result.min;
                        }
                    }, function(err) {
                        console.log('error')
                        console.log(err)
                    })
                } else {
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                    $scope.$broadcast('updatedData', model.tableIdentifiers.id);
                }
            })
        $scope.$on('$destroy', function() {
            socket.disconnect();
        });
    })
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;



/** WEBPACK FOOTER **
 ** ./src/pages/controllers/general_network/inbound_resp.js
 **/